import ProfileContainerReducer from './ProfileContainerReducer';

export default from './ProfileContainer';
export const ProfileContainerReducers = {
  ProfileContainerReducer,
};
